import axios from "axios";
import { Base_URL } from "../url";

export const saveSupplyType = async (supplyTypeData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SupplyTypeMaster/CreateSupplyType?UserName=${userName}`,
      supplyTypeData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving supply type details!";
  }
};